import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=72fe37b6&lang=pug"
import script from "./ImageSlider.vue?vue&type=script&lang=js"
export * from "./ImageSlider.vue?vue&type=script&lang=js"
import style0 from "./ImageSlider.vue?vue&type=style&index=0&id=72fe37b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports